export default "__VITE_ASSET__CD5TMsc3__"